// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ═══════════════════════════════════════════════════════════════
   ReportDocument + dedicated print-root styles
   ═══════════════════════════════════════════════════════════════ */

/* Screen contract: the print root is always hidden on screen. */
#report-print-root {
  display: none;
}

/*
 * Print contract: the screen app and the printable document are two separate
 * render targets. Printing shows ONLY #report-print-root content.
 */
@media print {
  @page {
    margin: 12mm;
  }

  :root {
    color-scheme: light;
  }

  html,
  body {
    background: #ffffff !important;
    margin: 0 !important;
    padding: 0 !important;
  }

  #app,
  #app * {
    display: none !important;
  }

  #report-print-root {
    display: block !important;
  }

  #report-print-root * {
    print-color-adjust: exact;
  }

  .report-document {
    box-shadow: none !important;
    border: none !important;
    border-radius: 0 !important;
    max-width: 100% !important;
    margin: 0 !important;
    width: 100% !important;
  }

  .rd-no-break {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .report-document table {
    break-inside: avoid;
    page-break-inside: avoid;
  }

  .report-document thead {
    display: table-header-group;
  }

  /* Safari/Firefox fallback: make sure backgrounds still print */
  .report-document,
  .report-document * {
    print-color-adjust: exact !important;
  }
}

/* Full Report A4 page-sheet preview (screen) */
.rd-page-sheet {
  background: #ffffff;
  border-radius: 12px;
  box-shadow: 0 8px 30px rgba(2, 6, 23, 0.12);
  border: 1px solid rgba(2, 6, 23, 0.08);
  overflow: hidden;
  margin: 0 auto;
}

.dark .rd-page-sheet {
  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);
}

.rd-page-sheet > .report-document {
  background: #ffffff;
}`, "",{"version":3,"sources":["webpack://./src/reports/ReportStyles.css"],"names":[],"mappings":"AAAA;;oEAEoE;;AAEpE,gEAAgE;AAChE;EACE,aAAa;AACf;;AAEA;;;EAGE;AACF;EACE;IACE,YAAY;EACd;;EAEA;IACE,mBAAmB;EACrB;;EAEA;;IAEE,8BAA8B;IAC9B,oBAAoB;IACpB,qBAAqB;EACvB;;EAEA;;IAEE,wBAAwB;EAC1B;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IAEE,yBAAyB;EAC3B;;EAEA;IACE,2BAA2B;IAC3B,uBAAuB;IACvB,2BAA2B;IAC3B,0BAA0B;IAC1B,oBAAoB;IACpB,sBAAsB;EACxB;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,mBAAmB;IACnB,wBAAwB;EAC1B;;EAEA;IACE,2BAA2B;EAC7B;;EAEA,+DAA+D;EAC/D;;IAEE,oCAAoC;EACtC;AACF;;AAEA,+CAA+C;AAC/C;EACE,mBAAmB;EACnB,mBAAmB;EACnB,2CAA2C;EAC3C,sCAAsC;EACtC,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;AACrB","sourcesContent":["/* ═══════════════════════════════════════════════════════════════\n   ReportDocument + dedicated print-root styles\n   ═══════════════════════════════════════════════════════════════ */\n\n/* Screen contract: the print root is always hidden on screen. */\n#report-print-root {\n  display: none;\n}\n\n/*\n * Print contract: the screen app and the printable document are two separate\n * render targets. Printing shows ONLY #report-print-root content.\n */\n@media print {\n  @page {\n    margin: 12mm;\n  }\n\n  :root {\n    color-scheme: light;\n  }\n\n  html,\n  body {\n    background: #ffffff !important;\n    margin: 0 !important;\n    padding: 0 !important;\n  }\n\n  #app,\n  #app * {\n    display: none !important;\n  }\n\n  #report-print-root {\n    display: block !important;\n  }\n\n  #report-print-root * {\n    -webkit-print-color-adjust: exact;\n    print-color-adjust: exact;\n  }\n\n  .report-document {\n    box-shadow: none !important;\n    border: none !important;\n    border-radius: 0 !important;\n    max-width: 100% !important;\n    margin: 0 !important;\n    width: 100% !important;\n  }\n\n  .rd-no-break {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .report-document table {\n    break-inside: avoid;\n    page-break-inside: avoid;\n  }\n\n  .report-document thead {\n    display: table-header-group;\n  }\n\n  /* Safari/Firefox fallback: make sure backgrounds still print */\n  .report-document,\n  .report-document * {\n    print-color-adjust: exact !important;\n  }\n}\n\n/* Full Report A4 page-sheet preview (screen) */\n.rd-page-sheet {\n  background: #ffffff;\n  border-radius: 12px;\n  box-shadow: 0 8px 30px rgba(2, 6, 23, 0.12);\n  border: 1px solid rgba(2, 6, 23, 0.08);\n  overflow: hidden;\n  margin: 0 auto;\n}\n\n.dark .rd-page-sheet {\n  box-shadow: 0 8px 30px rgba(0, 0, 0, 0.5);\n}\n\n.rd-page-sheet > .report-document {\n  background: #ffffff;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
